// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"104":"kindle","152":"device","486":"orders","985":"res"}[chunkId] || chunkId) + "-legacy." + {"22":"224a60d6","104":"1ec758c5","152":"68b317fe","486":"e9439291","985":"125b16c7"}[chunkId] + ".js";
};